import { OddsBar } from './OddsBar';

export interface OddsBarsListProps {
  /** Per-rarity breakdown from the backend (`odds.tiers`). */
  tiers: { tierName: string; range: string; percentage: number }[];
}

/** Vertical stack of rarity bars — shared by the odds modal (mobile) and
 *  popover (desktop) so both render the breakdown identically. */
export function OddsBarsList({ tiers }: OddsBarsListProps) {
  return (
    <div className="flex w-full flex-col gap-1">
      {tiers.map((t) => (
        <OddsBar
          key={`${t.tierName}-${t.range}`}
          name={t.tierName}
          range={t.range}
          percentage={t.percentage}
        />
      ))}
    </div>
  );
}
